"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the Apache License. See License in the project root for license information.
Object.defineProperty(exports, "__esModule", { value: true });
const connection_1 = require("./connection");
const session_1 = require("./session");
const link_1 = require("./link");
const log = require("./log");
var EventContext;
(function (EventContext) {
    /**
     * Translates rhea's EventContext into rhea-promise EventContext
     * @param rheaContext The received context from rhea's event emitter
     * @param emitter The rhea-promise equivalent object that is supposed emit the same event
     * @param eventName The name of the event for which the context will be translated
     *
     * @returns EventContext The translated EventContext.
     */
    function translate(rheaContext, emitter, eventName) {
        const connection = emitter instanceof connection_1.Connection
            ? emitter
            : emitter.connection;
        log.contextTranslator("[%s] Translating the context for event: '%s'.", connection.id, eventName);
        // initialize the result
        const result = Object.assign({ _context: rheaContext }, rheaContext);
        // set rhea-promise connection and container
        result.connection = connection;
        result.container = connection.container;
        // set rhea-promise session, sender/receiver.
        if (emitter instanceof link_1.Link) {
            result.session = emitter.session;
            if (emitter.type === link_1.LinkType.receiver && rheaContext.receiver) {
                result.receiver = emitter;
            }
            else if (emitter.type === link_1.LinkType.sender && rheaContext.sender) {
                result.sender = emitter;
            }
        }
        else if (emitter instanceof session_1.Session) {
            result.session = emitter;
        }
        return result;
    }
    EventContext.translate = translate;
})(EventContext = exports.EventContext || (exports.EventContext = {}));
//# sourceMappingURL=eventContext.js.map